import React, { Fragment } from 'react';
import { getAnchorId } from '@/helpers/utils';
import Partner from './Partner';
import { Profile } from '../interface';
import Divider from '../Divider';

interface PartnerProfilesProps {
  partners: Profile[];
}

const PartnerProfiles: React.FC<PartnerProfilesProps> = ({ partners }) => (
  <>
    {partners.map((partner, idx) => {
      const anchorId = getAnchorId({
        type: 'partner',
        name: partner.name,
        title: undefined,
        idx,
        section: partner.header,
      });
      return (
        <Fragment key={partner.name}>
          <h2 className="margin-3-b color-text-emphasis tw-col-span-6 tw-col-start-2 tw-text-2xl">
            {partner.header}
          </h2>
          <Partner partner={partner} anchorId={anchorId} />
          <Divider />
        </Fragment>
      );
    })}
  </>
);

export default PartnerProfiles;
